export default __webpack_public_path__ + "static/media/06.dd10f088.jpg";